// @flow
import { extendObservable, action } from "mobx";
import FilterObject, {
  FilterWithSort,
  ValueSetFilter,
  FilterCriteriaLoader,
  IViewItem,
} from "../Filter";
import type FilterColumn from "../Filter";
import { GraphQLQuery } from "../GraphQL";
import Sort from "../Sort";
import SortState from "../SortState";

class OwnerItem implements IViewItem {
  id: string;
  name: string;

  constructor(object: Object) {
    this.id = object.node.clientId;
    this.name = object.node.name;

    extendObservable(this, {
      selected: object.node.selected,
    });
  }
}

export default class ClientUserFilter extends FilterCriteriaLoader(
  ValueSetFilter(FilterWithSort)
) {
  constructor(
    store: Object,
    column: FilterColumn,
    filterCriteriaQuery: (FilterColumn) => GraphQLQuery,
    processPayload: (FilterColumn, Object) => Array<Object>,
    applyFilter: (FilterColumn, FilterObject) => void,
    applySort: (FilterColumn, Sort) => void,
    removeFilter: (FilterColumn) => void,
    removeSort: (FilterColumn) => void,
    reloadCriteria: boolean = false
  ) {
    super(store, column);

    this.filterCriteriaQuery = filterCriteriaQuery;
    this.processPayload = processPayload;
    this.applyFilter = applyFilter;
    this.applySort = applySort;
    this.removeFilter = removeFilter;
    this.removeSort = removeSort;
    this.column = column;

    if (this.column === "clientUserList") {
      this.sortState = new SortState("FIRST_NAME");
    } else if (this.column === "nwClinetList") {
      this.sortState = new SortState("NAME");
    } else {
      this.sortState = new SortState("OWNER_FIRST_NAME");
    }

    this.reloadCriteria = reloadCriteria;

    this.viewItemClass = OwnerItem;

    this.buildQueryFilter = action(this.buildQueryFilter.bind(this));
    this.onInstantSearch = action(this.onInstantSearch.bind(this));
  }

  onInstantSearch(value: string) {
    if (super.onInstantSearch) super.onInstantSearch(value);

    if (!this.instantSearchValue) {
      this.viewItems = this.unfilteredViewItems;
      return;
    }

    this.viewItems = this.unfilteredViewItems.filter((owner) => {
      const name = owner.name.toLowerCase();

      const query = this.instantSearchValue.toLowerCase();

      // this works because ~ is the binary inverse of a number and ~ -1 = 0
      return ~name.indexOf(query);
    });
  }

  buildQueryFilter() {
    const owners = this.selectedValues
      .entries()
      .filter((entry) => entry[1] === true)
      .map((entry) => this.criteria.get(entry[0]).id);

    if (!owners.length) {
      return null;
    }

    let params = [];
    let args = [];
    let vars = {};

    if (this.column === "clientUserList") {
      params.push("$clientIn: [Int]");
      args.push("clientIn: $clientIn");
      vars.clientIn = owners.map((userId) => {
        return userId;
      });
    } else {
      if (owners.length) {
        params.push("$clientidIn: [Int]");
        args.push("clientidIn: $clientidIn");
        vars.clientidIn = owners.map((userId) => {
          return userId;
        });
      }
    }

    return new FilterObject(params.join(", "), args.join(", "), vars);
  }
}
